// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"133":"5492ae59","257":"a354c62e"}[chunkId] + ".chunk.js";
};